import PrebuiltAccaAvantgardeImpl from './prebuilt-acca-avantgarde.js';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';

const UIView = MojitoCore.Presentation.UIView;

/**
 * PrebuiltAccaAvantgarde view that renders prebuilt acca card with the avantgarde layout.
 *
 * @class PrebuiltAccaAvantgarde
 * @memberof Mojito.Modules
 */

/**
 * PrebuiltAccaAvantgarde prop types.
 *
 * @property {object} event - Event data.
 * @property {object} market - Market data.
 * @property {string|undefined} [promotionText] - Promotion text to be displayed on the card. Used as the card title, falling back to the common market name of the parts.
 * @property {Function} [onEventClick] - Callback to get state of child element loading.
 * @property {boolean} [shouldRequestData = true] - Flag indicating whether the part events and markets should be requested from content. If false, then part metadata is resolved from the data already available in a store.
 *
 * @memberof Mojito.Modules.PrebuiltAccaAvantgarde
 */
const propTypes = {
    event: PropTypes.object.isRequired,
    market: PropTypes.object.isRequired,
    promotionText: PropTypes.string,
    onEventClick: PropTypes.func,
    shouldRequestData: PropTypes.bool,
};

const defaultProps = {
    shouldRequestData: true,
};

export default UIView(
    'PrebuiltAccaAvantgarde',
    PrebuiltAccaAvantgardeImpl,
    propTypes,
    defaultProps
);
